import React from 'react'
import { NavLink } from 'react-router-dom'
import LoginForm from './LoginForm'
import LoginRegisterHeader from '../../components/HeaderLoginRegister'
import LoginRegisterHeaderRwd from '../../components/HeaderLoginRegisterRwd'
import LoginRegisterLogo from '../../components/LogoLoginRegister'
import { usePublicSettings } from '../../myHooks/useSettings'
import { useTranslation } from 'react-i18next'
import { resolveInvesthubSsoUrl } from '../../utils/investhubSsoUrl'

const buildSsoRequestUrl = (publicSettings, companyType) => {
  const base = resolveInvesthubSsoUrl(publicSettings)
  // Tenant KYC investor login must send company_type=investor (manage only for admin link).
  const type = companyType === 'manage' ? 'manage' : 'investor'
  const params = new URLSearchParams({
    redirect: `${window.location.origin}/sso/auth`,
    company_id: publicSettings.investhub_company_id || '',
    company_type: type,
  })
  return `${base}/sso/request?${params.toString()}`
}

const Login = () => {
  const { data: { publicSettings = {} } = {} } = usePublicSettings();
  const { t } = useTranslation();
  const ssoEnabled = Boolean(publicSettings.sso_enabled)
  const companyDisplayName = (
    (publicSettings.company && publicSettings.company.name)
    || publicSettings.token_name
    || ''
  ).trim()
  const investhubUrl = resolveInvesthubSsoUrl(publicSettings)

  return (
    <>
      <LoginRegisterHeader>
        <a href={investhubUrl}>{ t('Back to Investhub') }</a>
        { !ssoEnabled && <NavLink to="/password/restore">{ t('Forgot your password') }</NavLink> }
      </LoginRegisterHeader>

      <LoginRegisterHeaderRwd>
        <div className="actions__option actions__option_normal d__block">
          <a href={investhubUrl}>{ t('Back to Investhub') }</a>
        </div>
        {
          !ssoEnabled && (
            <div className="actions__option actions__option_normal d__block">
              <NavLink to="/password/restore">{ t('Forgot your password') }</NavLink>
            </div>
          )
        }
      </LoginRegisterHeaderRwd>

      <div className="entry entry_loginregister">
        <div className="entry__wrapper entry__wrapper-kyc">
          <LoginRegisterLogo />

          <div className="h2 entry__title">
            { t('Sign In') }
          </div>

          {ssoEnabled ? (
            <>
              <div className="entry__text">{ t('Continue with Investhub') }</div>
              {companyDisplayName ? (
                <div className="entry__info" style={{ marginBottom: '0.75rem' }}>
                  {t('Use the email you submitted for {{company}}', { company: companyDisplayName })}
                </div>
              ) : null}
              <div className="entry__fieldset">
                <div className="field input-submit">
                  <a
                    className="button entry__button"
                    href={buildSsoRequestUrl(publicSettings, 'investor')}
                  >
                    { t('Continue with Investhub') }
                  </a>
                </div>
                <div className="entry__info">
                  <a href={buildSsoRequestUrl(publicSettings, 'manage')}>
                    { t('Sign in as admin via Investhub') }
                  </a>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="entry__text">{ t('Sign in with email address') }</div>
              <LoginForm />
            </>
          )}

          <div>
            {(publicSettings || {}).login_youtube_video && (
              <div className="entry__youtube_video">
                <iframe
                  title="video"
                  width="426"
                  height="240"
                  type="text/html"
                  src={`${publicSettings.login_youtube_video}?autoplay=1&controls=0&disablekb=1&fs=0&iv_load_policy=3&loop=1&modestbranding=1&showinfo=0&autohide=1`}
                  frameBorder="0"
                />
              </div>
            )}

            <br />

            {(publicSettings || {}).first_link_login && (
              <p>
                <a className="button button__full" href={(publicSettings || {}).first_link_login} target="_blank" rel="noopener noreferrer">
                  {(publicSettings || {}).first_text_login || 'See more'}
                </a>
              </p>
            )}

            <br />

            {(publicSettings || {}).second_link_login && (
              <p>
                <a className="button button__full" href={(publicSettings || {}).second_link_login} target="_blank" rel="noopener noreferrer">
                  {(publicSettings || {}).second_text_login || 'Explore'}
                </a>
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
